export const getters = {
    getMarketActiveTab: state => state.marketActiveTab,
    getMarketActiveTabChild: state => state.marketActiveTabChild,
    getPositionScroll: state => state.positionScroll,
    getShowFooter: state => state.showFooter,
}
  